import { string } from "yup";
import { ACTIVITY_REGISTRATION_NUMBER_ERROR_MESSAGE } from "@shared-kernel/primary/forms/constants";
import { normalizeIdentifier } from "@utils/formatting";

export const activityRegistrationNumberValidation = (isRequired = false) => {
  const baseValidation = string().test("activityRegistrationNumber", ACTIVITY_REGISTRATION_NUMBER_ERROR_MESSAGE, value => {
    if (!value) return true;
    return /^\d{11}$/.test(normalizeIdentifier(value));
  });

  return isRequired ? baseValidation.required("Le numéro de déclaration d'activité est requis") : baseValidation;
};
